import React from "react";
import { Table, Badge } from "reactstrap";
import { formatModerationMessage } from "utils/formatMessage";

const EscalatedTable = ({ data }) => {
    return (
        <Table className="align-items-center moderation-table" responsive>
            <thead className="thead-light">
                <tr>
                    <th>Content</th>
                    <th>Escalated By</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Resolved By</th>
                    <th>Timestamp</th>
                    <th className="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => {
                    const cleanMessage = formatModerationMessage(item.message);
                    return (
                    <tr key={item.escalationId || index}>
                        <td style={{ maxWidth: "250px", whiteSpace: "normal" }}>
                            <span className="text-sm font-weight-600">
                                {cleanMessage?.length > 60 ? cleanMessage.substring(0, 60) + "..." : cleanMessage}
                            </span>
                            <small className="d-block text-muted text-xs">{item.type}</small>
                        </td>
                        <td>
                            <div className="d-flex align-items-center">
                                {item.escalatorImage ? (
                                    <img
                                        src={item.escalatorImage.startsWith("http") ? item.escalatorImage : `${process.env.REACT_APP_IMAGE_PATH || ""}${item.escalatorImage}`}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(item.escalatedBy || "User")}&background=fb6340&color=fff`;
                                        }}
                                        className="rounded-circle mr-2"
                                        style={{ width: "30px", height: "30px", objectFit: "cover" }}
                                        alt="admin"
                                    />
                                ) : (
                                    <div className="bg-lighter p-1 rounded-circle mr-2">
                                        <i className="ni ni-single-02 text-primary" style={{ fontSize: '14px' }} />
                                    </div>
                                )}
                                <div className="d-flex flex-column">
                                    <span className="text-sm font-weight-bold">{item.escalatedBy}</span>
                                    <small className="text-muted text-xs">{item.escalatorEmail}</small>
                                </div>
                            </div>
                        </td>
                        <td style={{ maxWidth: "150px" }}>
                            <small className="text-muted text-wrap d-block">
                                {item.escalationReason}
                            </small>
                        </td>
                        <td>
                            <Badge color={item.eh_status === 'pending' ? 'danger' : 'success'} className="status-badge-pill">
                                {item.eh_status}
                            </Badge>
                        </td>
                        <td>
                            <small className="font-weight-bold">{item.eh_resolved_by || "--"}</small>
                        </td>
                        <td>
                            <div className="text-xs text-muted">
                                <div>{new Date(item.escalatedAt).toLocaleDateString()}</div>
                                <div>{new Date(item.escalatedAt).toLocaleTimeString()}</div>
                            </div>
                        </td>
                        <td className="text-right">
                            {/* Actions if any */}
                        </td>
                    </tr>
                );
                })}
            </tbody>
        </Table>
    );
};

export default EscalatedTable;
